/**
 * 아이템 상태 라벨 ($숫자 → 한글)
 * L1J L1ItemInstance.getNumberedViewName()이 사용하는 status localization key
 * 데이터 출처: src/jp/l1j/server/model/instance/L1ItemInstance.java:957-982
 */
export const ITEM_LABELS: Readonly<Record<string, string>> = Object.freeze({
  // === 시간 표시: getNumberedViewName()의 유효기간 표시 부분 ===
  // (실제로는 month-day hour:minute로 동적 생성되므로 별도 처리 불필요)

  // ※ 키는 서버가 전송하는 형식 그대로 "($숫자)" (괄호 포함).
  //    호출측은 정규식 /\(\$\d+\)/g 로 추출한 매치 문자열을 그대로 넘긴다.

  // === 라이트/조명 상태: line 960-968 ===
  "($10)": "(점등중)",     // isNowLighting - 빛나는 중
  "($11)": "(불 꺼짐)",   // 40001/40002 램프/랜턴 + chargeTime <= 0

  // === 보호 상태: line 971-973 ===
  "($5904)": "(보호중)",

  // === 장비 상태: line 975-983 ===
  "($9)": "(장비)",       // 무기/방어구 type2==1
  "($117)": "(장비)",     // type2==2 (방어구 worn) 또는 petitem

  // === 펫 아이템: line 939-948 ===
  // "[Lv.X 이름]HP숯" 동적 — 펫 이름은 별도 처리
});
